module.exports = __webpack_public_path__ + "static/img/c.1873f8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/photo_pack/c.png
// module id = orhi
// module chunks = 12